import { gql } from 'apollo-boost';

export const updatePortfolioMutation = gql`
  mutation updatePortfolioMutation(
      $id: Int!,
      $name: String,
      $description: String,
      $status: String,
      $year: Int,
      $years: JSONString,
      $ReviewLevel: String,
      $isImpactSnapshot: Boolean,
  ) {
    updatePortfolio(
      id: $id,
      name: $name,
      description: $description,
      status: $status,
      year: $year,
      years: $years,
      ReviewLevel: $ReviewLevel,
      isImpactSnapshot: $isImpactSnapshot
  ) {
      success
    }
  }
`;
